import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/top-winning/img-san-sieu-hu-collapse-mb.webp")